import React from "react";
import { styled } from '@mui/material/styles';
import galleryStyles from './GalleryStyles';
import ImageCarousel from "../ImageCarousel/ImageCarousel";
import Separator from "../Separator/Separator";
import './Gallery.css';
import Button from "../Button/Button";

type GalleryImage = {
  src: string;
  alt: string;
};

type GalleryProps = {
  title: string;
  description: string;
  buttonText: string;
  images: GalleryImage[];
};

const StyledGallery = styled('section')(({ theme }) => galleryStyles(theme));

const Gallery: React.FC<GalleryProps> = ({ title, description, buttonText, images }) => (
  <StyledGallery id="galeria-equipos-disponibles" className='flex-col items-center overflow-hidden relative'>
    <div className="diagonal"></div>
    <div className="diagonal diagonal2"></div>
    <div className="diagonal diagonal3"></div>
    <div id="gallery-title" className="pt-[5rem] lg:pt-[8rem] text-4xl lg:text-6xl font-semibold text-center pb-[2rem] lg:pb-[1rem] px-6 z-10">{title}</div>
    <div className="flex flex-col items-center justify-center my-4 mx-8 z-10">
      <Separator className="mb-10"/>
      <div id="gallery-description" className="text-xl max-w-[54rem] text-center md:mx-24 mb-4">{description}</div>
      <div className="max-w-[15rem] mt-6 mb-8 lg:mb-14">
        <Button fullWidth href="/contacto">{buttonText}</Button>
      </div>
    </div>
    <ImageCarousel images={images} />
  </StyledGallery>
);

export default Gallery;